import type Immutable from 'immutable';

import { Organization } from './Organization';
import { OrganizationType } from './OrganizationType';

export interface OrganizationImmutable
  extends Immutable.Map<keyof Organization, any | undefined> {
  toJS(): Organization;
  get<K extends keyof Organization>(key: K): Organization[K];
}

export const getOrganizationId = (
  organization: OrganizationImmutable,
): number => organization?.get('id');

export const getOrganizationType = (
  organization: OrganizationImmutable,
): OrganizationType => organization?.get('type');
